import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-50a93266"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "basic",
  ref: "basic"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "title"
  }, "业务信息", -1);
});

var _hoisted_3 = {
  class: "row"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "关联业务", -1);
});

var _hoisted_5 = {
  key: 0,
  class: "value notEditable"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconplus-line"
  }, null, -1);
});

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" 新增业务 ");

var _hoisted_8 = [_hoisted_6, _hoisted_7];
var _hoisted_9 = {
  key: 0,
  class: "row"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "默认集群", -1);
});

var _hoisted_11 = {
  class: "value notEditable"
};
var _hoisted_12 = {
  class: "row"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "空间自定义帮助文档", -1);
});

var _hoisted_14 = {
  key: 1,
  class: "row"
};

var _hoisted_15 = /*#__PURE__*/_createTextVNode("编辑");

var _hoisted_16 = /*#__PURE__*/_createTextVNode("保存");

var _hoisted_17 = /*#__PURE__*/_createTextVNode("取消");

import { ref, reactive, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import CompanyService from '@/api/company';
import { asyncComputed } from '@vueuse/core';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var store = useStore(); // 是否是编辑状态

    var isEdit = ref(false);
    var outerWebFlag = ref(window.AppConfig.outerWebFlag); // 编辑表单

    var editItem = reactive({
      busiId: '',
      docUrl: ''
    });
    var spaceDetail = computed(function () {
      return store.state.company.spaceDetail;
    });
    var hasEditAuth = computed(function () {
      return store.state.company.hasEditAuth;
    }); // 空间自定义帮助文档 placeholder

    var docUrlPlaceholder = computed(function () {
      if (!isEdit.value && !editItem.docUrl) return '暂无内容';
      return '请输入包含http://或https://的完整URL';
    }); // 管理业务选择是否禁用

    var disabledChangeBusiId = computed(function () {
      return !(isEdit.value && spaceDetail.value.busiId === '0');
    }); // 管理业务下拉列表

    var businessList = asyncComputed( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$CompanyService, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!outerWebFlag.value) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", []);

            case 2:
              _context.next = 4;
              return CompanyService.queryBusinessList({
                corporationId: spaceDetail.value.corporationId,
                pageNo: 1,
                pageSize: 1e6
              });

            case 4:
              _yield$CompanyService = _context.sent;
              data = _yield$CompanyService.data;
              return _context.abrupt("return", data.result.itemList.map(function (business) {
                return {
                  value: business.busiId,
                  label: "".concat(business.busiName)
                };
              }));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    /**
     * 点击取消触发
     */

    var onClickCancel = function onClickCancel() {
      isEdit.value = false;
      Object.assign(editItem, {
        busiId: spaceDetail.value.busiId,
        docUrl: spaceDetail.value.docUrl
      });
    };
    /**
     * 点击新增业务触发
     */


    var onClickAddBusi = function onClickAddBusi() {
      router.push({
        name: 'Business'
      });
    };
    /**
     * 修改企业信息
     */


    var updateCompanyInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _data$data;

        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return CompanyService.bizAssociateBusi({
                  appGroup: 'beacon',
                  bizId: route.params.biz_url,
                  bizName: spaceDetail.value.name,
                  busiId: editItem.busiId,
                  docUrl: editItem.docUrl
                });

              case 2:
                data = _context2.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  ElMessage({
                    message: '修改业务信息成功',
                    type: 'success'
                  });
                  store.dispatch('company/getSpaceDetail', {
                    bizId: route.params.biz_url,
                    appGroup: 'beacon'
                  });
                  isEdit.value = false;
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function updateCompanyInfo() {
        return _ref2.apply(this, arguments);
      };
    }();

    watch(function () {
      return spaceDetail.value;
    }, function () {
      editItem.busiId = spaceDetail.value.busiId;
      editItem.docUrl = spaceDetail.value.docUrl;
    }, {
      immediate: true
    });
    return function (_ctx, _cache) {
      var _component_el_select_v2 = _resolveComponent("el-select-v2");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, outerWebFlag.value ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(spaceDetail).busiName || ''), 1)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_el_select_v2, {
        modelValue: _unref(editItem).busiId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _unref(editItem).busiId = $event;
        }),
        disabled: _unref(disabledChangeBusiId),
        options: _unref(businessList) || [],
        filterable: "",
        class: "custom-input",
        placeholder: "请选择关联业务"
      }, null, 8, ["modelValue", "disabled", "options"]), isEdit.value ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "add-bussiness",
        onClick: onClickAddBusi
      }, _hoisted_8)) : _createCommentVNode("", true)], 64))]), !outerWebFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(spaceDetail).defaultClusterId || ''), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_component_el_input, {
        modelValue: _unref(editItem).docUrl,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _unref(editItem).docUrl = $event;
        }),
        disabled: !isEdit.value,
        class: "custom-input",
        placeholder: _unref(docUrlPlaceholder)
      }, null, 8, ["modelValue", "disabled", "placeholder"])]), _unref(hasEditAuth) ? (_openBlock(), _createElementBlock("div", _hoisted_14, [!isEdit.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "primary-button edit-info",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return isEdit.value = true;
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_15];
        }),
        _: 1
      })) : _createCommentVNode("", true), isEdit.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        class: "primary-button save",
        type: "primary",
        onClick: updateCompanyInfo
      }, {
        default: _withCtx(function () {
          return [_hoisted_16];
        }),
        _: 1
      })) : _createCommentVNode("", true), isEdit.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        class: "normal-button cancel",
        type: "primary",
        onClick: onClickCancel
      }, {
        default: _withCtx(function () {
          return [_hoisted_17];
        }),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 512);
    };
  }
});